<ng-container *ngIf="!user">
    <h2>Dina personuppgifter</h2>
    <p id="pers-data-desc">Skolverket använder ditt personnummer för att kontrollera eventuell befintlig lärar- och
        förskollärarlegitimation. Om du har en legitimation sedan tidigare kommer du ansöka om att komplettera
        legitimationen med fler behörigheter.
    </p>
    <app-input [control]="ssn" data-test-id="applicantSsn" aria-describedby="pers-data-desc">Personnummer (ååååmmddnnnn)
    </app-input>
</ng-container>

<ng-container *ngIf="user && allowSsnChange">
    <h2>Ändra personnummer</h2>
    <app-input [control]="ssn" data-test-id="applicantSsn">Personnummer (ååååmmddnnnn)</app-input>
</ng-container>

<app-banner *ngIf="revoked" type="error">
    <h3>Återkallad legitimation</h3>
    <p>Du har tidigare fått din legitimation återkallad och kan därför inte göra en ny ansökan. För mer information
        kontakta informationtjänsten.</p>
</app-banner>

<h2>Behandling av personuppgifter</h2>
<p>
    Personuppgifter som lämnas i samband med din ansökan registreras av Skolverket i ett ärendehanteringssystem. Om
    du
    meddelas legitimation kommer uppgifterna att överföras till Skolverkets lärar- eller förskollärarregister.
</p>
<p>
    Skolverkets behandling av personuppgifterna regleras genom förordningen (2011:268) om lärar- och
    förskollärarregistret
    samt i enlighet med kraven i dataskyddsförordningen (Europaparlamentets och rådets förordning (EU) 2016/679) med
    tillhörande nationell lagstiftning.
</p>
<app-reveal title="Personuppgiftsbehandling inom lärar- och förskollärarregistret">
    <h3>Syfte med behandling av dina personuppgifter</h3>
    <p>
        Vi behandlar dina personuppgifter inom ditt ärende för att handlägga ansökan om legitimation. Vi behöver ha
        personuppgifter för att kunna kontakta dig, för att verifiera och styrka dina uppgifter samt kunna göra korrekta
        bedömning av ditt ärende. Detta innebär att:
    </p>
    <ul>
        <li>Vi kommer att i ansökan inhämta uppgifter om hur vi kontaktar dig. Epost och telefonnummer samt vilket
            personnummer du har. Vi kommer även att be att få intyg och handlingar som styrker dina yrkanden.</li>
        <li>Vi kommer även att inhämta personuppgifter från folkbokföringen för att säkerställa identitet i handlingarna
            samt kompletterande kontaktuppgifter.</li>
        <li>Vi kommer även att inhämta personuppgifter från Ladok för att komplettera eller förtydliga inskickade
            handlingar och uppgifter.</li>
        <li>Vi kommer även att inhämta information från lärosäten för att komplettera eller förtydliga inskickade
            handlingar och uppgifter.</li>
    </ul>

    <h3>Vem är ansvarig för personuppgiftsbehandlingarna</h3>
    <p>Skolverket (org. nr. är 202100-4185) är personuppgiftsansvarig för behandlingen av dina personuppgifter.</p>
    <p>
        Skolverket<br />
        Box 4002<br />
        171 04 Solna<br />
        Upplysningstjänst och växel: 08-527 332 00<br />
    </p>

    <h3>Grunden för Skolverket att behandla dina personuppgifter</h3>
    <p>
        Enligt § 16 i skollagen (2010:800) ska Statens skolverk efter ansökan meddela legitimation till en lärare eller
        förskollärare som har behörighetsgivande examen. Enligt förordning (2011:268) om lärar- och förskollärarregister
        § 5 får Statens Skolverk behandla personuppgifter om det är nödvändigt för att föra en aktuell förteckning över
        legitimerade lärare och förskollärare. Utöver detta får Statens Skolverket även behandla personuppgifter enligt
        § 6 för att:
    </p>
    <ul>
        <li>Handlägga ärenden om legitimation.</li>
        <li>Lämna uppgifter till utländska myndigheter i enlighet med förordningen (2016:157) om erkännande av
            yrkeskvalifikationer.</li>
        <li>Utöva tillsyn av skolväsendet och dess personal.</li>
        <li>Kontrollera identitet och behörighet i samband med tjänstetillsättning av lärare och förskollärare.</li>
    </ul>
    <p>
        Personuppgiftsbehandlingen utförs för att Skolverket genom dessa författningar fått i uppdrag att fullgöra dessa
        uppgifter. Skolverkets behandling av personuppgifter utförs på den rättsliga grunden att det är nödvändigt för
        att utföra dessa myndighetsuppgifter och därigenom utföra en uppgift av allmänt intresse.
    </p>

    <h3>Eventuella mottagare av personuppgifter</h3>
    <p>Skolverket kommer i följande fall att skicka personuppgifter till externa mottagare.</p>
    <ol>
        <li>Vid bedömningen av ärenden med utländska examina kommer Skolverket att skicka personuppgifter till
            Universitets- och högskolerådet (UHR) för bedömning av utländska examina.</li>
        <li>Skolverket kommer att anlita en extern bedömare för att kunna handlägga ärenden med yrkesämnen. Vi kommer
            skriva ett avtal med den externa bedömaren så att dina personuppgifter hanteras i enlighet med lag hos dem.
        </li>
    </ol>
    <p>Uppgifter som betraktas som allmän handling kan också komma att lämnas ut i enlighet med offentlighetsprincipen
        om det inte bedöms råda sekretess för dem.</p>

    <h3>Överföring av uppgifter till tredje land</h3>
    <p>Skolverket överför inte uppgifter till tredjeland till eller till någon internationell organisation.</p>

    <h3>Hur länge sparas uppgifterna?</h3>
    <p>De personuppgifter som vi hämtat in om dig kommer att bevaras i ditt ärende som i sin tur återfinns vårt diarium
        och tillika ärendehanteringssystem. Detta för att de utgör allmänna handlingar hos Skolverket kommer att bevara
        de enlighet med arkivlagen (1990:782).</p>

    <h3>Dina rättigheter</h3>
    <p>Du har från Skolverket begära tillgång till (Artikel 15 GDPR) och rättelse av dina personuppgifter som är under
        behandling (Artikel 16 GDPR). Detta gör du genom hemsidan:
        <a target="blank"
            href="https://www.skolverket.se/om-oss/begara-registerutdrag-med-personuppgifter">
            https://www.skolverket.se/om-oss/begara-registerutdrag-med-personuppgifter</a>
    </p>
    <p>
        Enligt registerförordning (2011:268) § 3 gäller inte Artikel 21. 1 i EU dataskyddsförordningen för sådan
        behandling av personuppgifter som förordning (2011:268) tillåter. Detta betyder har inte rätt att invända mot
        behandlingen eller begära begränsning av behandling av uppgifter som rör dig grundat på artikel 6.1 E eller F.
        Du
        har däremot rätt att invända att dina personuppgifter används för direkt marknadsföring och kan därför kontakta
        Skolverket för att säkerställa denna rätt.
    </p>
    <p>Skolverkets dataskyddsombud nås via dataskyddsombudet&#64;skolverket.se</p>

    <h3>Utdrag från lärar- och förskollärarregistret</h3>
    <p>Alla lärare och förskollärare som har fått legitimation finns i lärar- och förskollärarregistret. Informationen
        är allmän handling och vem som helst har rätt att begära utdrag ur registret. Det är från detta register som
        utdrag görs för att bland annat uppfylla behovet av att kontrollera behörighet och utöva tillsyn av
        skolväsendet.</p>
    <p>Utdrag från lärar- och förskollärarregistret gör på: lleg.registerutdrag&#64;skolverket.se</p>

    <h3>Klagomål till Integritetsskyddsmyndigheten</h3>
    <p>Om du anser att Skolverket har behandlat dina personuppgifter i strid med Dataskyddsförordningen eller den
        svenska dataskyddslagen har du också rätt att vända dig till Integritetsskyddsmyndigheten (IMY)för att klaga på
        det.</p>
    <p>Datainspektionen nås via imy&#64;imy.se</p>

    <h3>Om EU:s dataskyddsförordning (GDPR)</h3>
    <p>EU:s dataskyddsförordning (GDPR) är det grundläggande regelverket för behandling av personuppgifter. Därtill
        finns kompletterande bestämmelser i svenska lagar och andra författningar.
        Utöver dataskyddsförordningen (GDPR) finns regler i nationell lagstiftning som gäller för viss
        personuppgiftsbehandling.
    </p>
    <p>Inom lärar- och förskollärarregistret finns det bestämmelser om personuppgiftsbehandling i Förordning (2011:268)
        om lärar- och förskollärarregister.</p>
    <p>I dataskyddsförordningen finns ett antal grundläggande principer som gäller för all personuppgiftsbehandling och
        som personuppgiftsansvariga behöver tänka på.</p>
    <ul>
        <li>Laglighet, korrekthet och öppenhet</li>
        <li>Ändamålsbegränsning</li>
        <li>Uppgiftsminimering</li>
        <li>Riktighet</li>
        <li>Lagringsminimering</li>
        <li>Integritet och konfidentialitet</li>
        <li>Ansvarsskyldighet</li>
    </ul>
    <p>All personuppgiftsbehandling måste ha stöd i dataskyddsförordningen.</p>
</app-reveal>
